import React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm } from "antd/lib/form/Form";
import { toast } from "react-hot-toast";
import { Button, Col, Form, Row, Select } from "antd";
import { db, auth } from "../../../../../../firebase";
import { collection, addDoc, doc, query, where, getDocs, updateDoc } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth"
import {
  SelectMoveInTenantInfo, setPropertyUnitInformation,
} from "../../../../../../store/moveInTenantSlice";

import SubHeading from "../../../../../../components/common/SubHeading";
import WarningMessage from "../../../../../../components/common/WarningMessage";

function SelectUnit({ current, setCurrent }) {
  const [propertyUnits, setPropertyUnits] = useState([]);
  const [propertyUnitValue, setPropertyUnitValue] = useState("");
  const [propertyUnit, setPropertyUnit] = useState({});
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(
        usersRef,
        where("uid", "==", user.uid)
      );

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);
  const tenantData = useSelector(SelectMoveInTenantInfo);

  const navigate = useNavigate();
  const [form] = useForm();
  const dispatch = useDispatch();

  const next = () => {
    setCurrent(current + 1);
  };
  const prev = () => {
    setCurrent(current - 1);
  };

  useEffect(() => {
    if(companyName){
    const fetchPropertyUnits = async () => {
     
        try {
          const propertyUnitRef = collection(
            db,
            "companies",
            companyName,
            "properties"
          );
          const snapshot = await getDocs(propertyUnitRef); // Use getDocs to fetch the collection
  
          const fetchedData = snapshot.docs.map((doc) => ({
            id: doc.id,
            value:
              doc.data().propertyNameAddress.propertyName +
              " - " +
              doc.data().propertyNameAddress.propertyAddressOne +
              " - " +
              doc.data().propertyNameAddress.city +
              ", " +
              doc.data().propertyNameAddress.country +
              "-" +
              doc.data().propertyNameAddress.state,
            ...doc.data(),
          }));
          console.log("data", fetchedData);
          setPropertyUnits(fetchedData);
        } catch (err) {
          console.error(err);
          alert(err.message);
        }
      };
      fetchPropertyUnits();
      }
  }, [companyName]);

  useEffect(() => {
    const newObject = propertyUnits.find(
      (item) => item.value === propertyUnitValue
    );
    console.log("new object", newObject);
    setPropertyUnit(newObject);
  }, [propertyUnitValue]);

  const handleChange = (value) => {
    setPropertyUnitValue(value);
  };

  const handleFormSubmit = () => {
    try {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const tenantRef = doc(companyDocRef, "tenants", tenantData.tenantId);

      updateDoc(tenantRef, {
        propertyId: propertyUnit?.id,
      });
      dispatch(setPropertyUnitInformation(propertyUnit));
      next();
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };
  const onFinishFailed = (errorInfo) => {
    toast.error("There are problems with one or more required fields");
    console.log("Failed:", errorInfo);
  };
  const firstName = tenantData.tenantInformation
    ? tenantData.tenantInformation.firstName
    : "";
  const lastName = tenantData.tenantInformation
    ? tenantData.tenantInformation.lastName
    : "";

  return (
    <div className="profile">
      <SubHeading
        subHeading={`Select an available unit for  ${firstName} ${lastName}`}
      />
      <Form
        layout="vertical"
        onFinish={handleFormSubmit}
        onFinishFailed={onFinishFailed}
        form={form}
      >
        <Row gutter={[0, 10]}>
          <Col span={24}>
            <WarningMessage message="A screening report is not detected for this tenant." />
          </Col>
          <Col span={24}>
            <Row gutter={[0, 10]}>
              <Col span={24}>
                <Row gutter={[6, 0]}>
                  <Col>
                    <Form.Item
                      label="Available Unit"
                      name="leaseSignedDate"
                      rules={[
                        { required: true, message: "Please select unit" },
                      ]}
                    >
                      <Select
                        options={propertyUnits}
                        placeholder="Select property unit"
                        onChange={(value) => handleChange(value)}
                      />
                    </Form.Item>
                    <p className="onclick-text">Browse Vacant Units</p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <p>Unit Information</p>
            <Row gutter={[0, 16]}>
              {propertyUnitValue !== "" ? (
                <Col span={24}>
                  <Row gutter={[0, 16]}>
                    <Col span={24}>
                      <span>{propertyUnit?.value}</span>
                    </Col>
                    <Col span={24}>
                      <Row>
                        <Col span={24}>
                          <strong>BD/BA</strong>
                        </Col>
                        <Col span={24}>
                          <span>
                            {propertyUnit?.rentalInformation
                              ? propertyUnit.rentalInformation?.bedrooms
                              : ""}{" "}
                            /{" "}
                            {propertyUnit?.rentalInformation
                              ? propertyUnit.rentalInformation?.bathrooms
                              : ""}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={24}>
                      <Row>
                        <Col span={24}>
                          <strong>Market Rent</strong>
                        </Col>
                        <Col span={24}>
                          {propertyUnit?.rentalInformation
                            ? propertyUnit.rentalInformation?.marketRent
                            : ""}
                        </Col>
                      </Row>
                    </Col>
                    <Col span={24}>
                      <Row>
                        <Col span={24}>
                          <strong>Security Deposite</strong>
                        </Col>
                        <Col span={24}>
                          {propertyUnit?.rentalInformation
                            ? propertyUnit.rentalInformation?.securityDeposit
                            : ""}
                        </Col>
                      </Row>
                    </Col>
                    <Col span={24}>
                      <Row>
                        <Col span={24}>
                          <strong>Status</strong>
                        </Col>
                        <Col span={24}>
                          <span>
                            {propertyUnit?.rentalInformation
                              ? propertyUnit.rentalInformation?.rentStatus
                              : ""}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                    <Col></Col>
                  </Row>
                </Col>
              ) : (
                <Col>
                  <span>No Unit Selected</span>
                </Col>
              )}
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={[8, 0]} justify="end">
              <Col>
                <Button type="primary" htmlType="submit">
                  Continue
                </Button>
              </Col>
              <Col>
                <Button onClick={() => prev()}>Previous</Button>
              </Col>
              <Col>
                <Button type="link" onClick={() => navigate("/")}>
                  Cancel Move In
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default SelectUnit;
